export default {"src":"/_next/static/media/AMSC.9703c738.svg","height":18,"width":18};